import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import auth from './auth'
import clubs from './clubs'
import members from './members'
import memberDocuments from './memberDocuments'
import coaches from './coaches'
import referees from './referees'
import settings from './settings'
import documents from './documents'
import officials from './officials'
import categories from './categories'
import disciplines from './disciplines'
import tournaments from './tournaments'
import tournamentImages from './tournamentImages'
import disciplineCategories from './disciplineCategories'
import tournamentDisciplines from './tournamentDisciplines'
import tournamentTeamDisciplines from './tournamentTeamDisciplines'
import seminars from './seminars'
import seminarDocuments from './seminarDocuments'
import seminarImages from './seminarImages'
import seminarClubDeductions from './seminarClubDeductions'
import ranking from './ranking'
import factory from './factory'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    users: factory('User'),
    clubDeductions: factory('ClubDeductions'),
    auth,
    clubs,
    coaches,
    members,
    memberDocuments,
    settings,
    referees,
    documents,
    officials,
    categories,
    disciplines,
    tournaments,
    tournamentImages,
    disciplineCategories,
    tournamentDisciplines,
    tournamentTeamDisciplines,
    seminars,
    seminarDocuments,
    seminarImages,
    seminarClubDeductions,
    ranking
  }
})

export default store
